import { styled } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

export default styled(Button)(({}) => ({
    margin: "5px",
    padding: "4px 8px",
    color: "white",
    minHeight: "22px",
    lineHeight: "16px",
    fontSize: "14px",
    backgroundColor: "#bf0000",
    border: "3px solid #bf0000",
    "&:hover": {
        backgroundColor: "white !important",
        color: "#bf0000 !important"
    },
    "&:focus": {
        backgroundColor: "white !important",
        color: "#bf0000 !important"
    },
    fontFamily: "Rakuten Sans UI, Trebuchet MS, Trebuchet, Arial, Helvetica, sans-serif"
}));
